module.exports = __webpack_public_path__ + "static/img/3bdab206242fdace1e419204cce1b99c.fa4404b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3bdab206242fdace1e419204cce1b99c.jpg
// module id = mBcM
// module chunks = 1